var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"frame",staticClass:"carousel-slide-img"},[_c('img',{ref:"img",staticClass:"carousel-slide-img__el",attrs:{"src":_vm.slide.image,"alt":_vm.caption,"draggable":"false"},on:{"load":_vm.onLoad}})])}
var staticRenderFns = []

export { render, staticRenderFns }